import React from "react";
import { Link } from "react-router-dom";
export default function Button({value,btn_link,click}) {
 // console.log(value,btn_link,click,"kkkk")
  return (
    <>
      <Link to={btn_link} className="btn prim" onClick={click}>{value}</Link>
    </>
  );
}
